module.exports = __webpack_public_path__ + "static/media/icon-dashboard-staff.3a6cb94b.svg";